import Api from 'api';
import React from "react";
import Items from './Items';
import AboutUs from "./AboutUs";
import { actions } from 'redux-store';
import { connect } from 'react-redux';
import CarouselHeader from './Header/index';
import { Navigation, Footer, Categories } from "components";

class Home extends React.Component {

  constructor(props) {

    super(props);

    this.api = new Api();

    this.state = { products: [] }

  }

  componentDidMount = async () => {

    const { docs = [] } = await this.api.fetch('products','all','');

    const product_list = docs.map(a => ({ ...a.data(), id: a.id }));

    //await this.api.index_data('products','id',product_list);

    return this.setState({ products: product_list });

  }

  componentDidUpdate = (prevProps,prevState) => {

    const { products } = this.state;

    const { product_list } = this.props;

    if (products.length===product_list.length) return;

    return this.props.update_product_list(products);

  }

  product_filter = (from=0,to=0) => {

    const { products } = this.state;

    return products.filter((a,i) => (i>=from-1 && i<=to-1));

  };

  render() {

    return (
      <section>
        <Navigation/>
        <CarouselHeader data={this.product_filter(5,10)}/>
        <Categories data={this.props.categories} start={0} end={4}/>
        <Items caption='New Arrivals Just For You' data={this.product_filter(1,10)}/>
        <Items caption='Our Most Popular Items' data={this.product_filter(11,20)}/>
        <Items caption='Todays Featured Sales' data={this.product_filter(21,30)}/>
        <AboutUs/>
        <Categories data={this.props.categories} start={4} end={8} minimal/>
        <Footer/>
      </section>
    );
  }
}

const mapStateToProps = ({ cache }) => ({ ...cache });

export default connect(mapStateToProps,{ ...actions })(Home)
